<template>
  <Landing>
    <ResetPwd :modal="modal"></ResetPwd>
  </Landing>
</template>
<script>
import Landing from '@/page/byl/landing.vue'
import ResetPwd from '@/components/common/find-pwd/reset.vue'
export default {
  components: { Landing, ResetPwd },
  mounted () {
  },
  data () {
    return {
      modal: false
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/page/byl/auth/reset-pwd-page.vue